import Splide from '@splidejs/splide';
import { Translations } from '../utils';
import './overflow-slider.scss';

export class OverflowSlider {
  constructor() {
    this.els = document.querySelectorAll('.js-overflow-slider');
    if (!this.els.length) return;

    this.init();
  }

  init() {
    this.els.forEach((el) => {
      const splide = new Splide(el, {
        type: 'slide',
        arrows: true,
        pagination: false,
        gap: '1.5rem',
        perPage: 4,
        focus: 0,
        trimSpace: true,
        snap: true,
        breakpoints: {
          992: {
            perPage: 3,
          },
          767: {
            perPage: 1.5,
          },
        },
        i18n: Translations.getSplideI18n(),
      });

      splide.mount();

      const next = el.querySelector('.splide__arrow--next');

      const updateArrows = () => {
        if (!window.matchMedia('(min-width: 992px)').matches) return;

        const { index } = splide;
        const last = splide.length - splide.options.perPage;

        if (index >= last) {
          next.classList.add('is-disabled');
        } else {
          next.classList.remove('is-disabled');
        }
      };

      updateArrows();
      splide.on('mounted move', updateArrows);
    });
  }
}
